export const IS_DEVELOPMENT = import.meta.env.MODE === 'development';

export const IS_PRODUCTION = import.meta.env.MODE === 'production';

export const USE_STAGING_COGNITO = import.meta.env.VITE_USE_STAGING_COGNITO === 'true';

export const API_HOST = import.meta.env.VITE_API_HOST || 'http://localhost:8080';

export const COMMIT_HASH = import.meta.env.VITE_COMMIT_HASH || null;

export const COGNITO_POOL_ID = IS_DEVELOPMENT || USE_STAGING_COGNITO ? 'eu-west-1_f30oMd6sO' : 'eu-west-1_f9Enh6hBe';

export const COGNITO_CLIENT_ID =
    IS_DEVELOPMENT || USE_STAGING_COGNITO ? '5bgv24ph8lmek6pssk9k4lq4ur' : '473ft22do45h1frtjmktd79m03';

export const COGNITO_OAUTH_DOMAIN =
    IS_DEVELOPMENT || USE_STAGING_COGNITO
        ? 'banktrack-staging.auth.eu-west-1.amazoncognito.com'
        : 'banktrack.auth.eu-west-1.amazoncognito.com';

export const AMPLITUDE_API_KEY = '9f61800e1031c8b4cdd91303592e0ff1';

export const POST_HOG_TOKEN = "phc_W7PzI1hXgGmrM9ZNht6zzytKlMwB57nTHAAjO8Ve9P8"

export const INTERCOM_APP_ID = 'od5t8j6o';

export const STRIPE_PK = IS_DEVELOPMENT || USE_STAGING_COGNITO ? 'pk_test_51MEswQFYK2SntuoKS2oZ0cD6hwKLSyxbiLkHwgkDnUeWhrV2A9XSMO4JZMxdWg81smJ2J5TOk9ADqSyWMhxoSfOB002adqYWip' : 'pk_live_51MEswQFYK2SntuoKSlseeF1eQfbNqLv59E9jqMqT0PknbVwkqs4K93fxyF52s6YlgVF2VnFVw0myI7asKJFOvHXJ004TjuGecf';

export const IS_STAGING = USE_STAGING_COGNITO || IS_DEVELOPMENT;

export const ENABLE_SENTRY = !IS_DEVELOPMENT;
export const SENTRY_ENVIRONMENT = USE_STAGING_COGNITO ? 'staging' : 'production'